export enum WelcomeStatusEnum {
    SIPARIS_GELECEK = '1',
    ARAC_GELDI = '2',
    ARAC_SAHAYA_ALINSIN = '3',
    ARAC_SAHAYA_ALINDI = '4',
    ARAC_KANTARA_GIRDI = '5',
    ARAC_RAMPAYA_YANASTI = '6',
    SIPARIS_ANTREPODA = '7',
    SIPARIS_SERBEST_DEPODA = '8',
}

export enum OfferStatusEnum {
    TAKIPTE = '1',
    ONAYLANDI = '2',
    REVIZE_EDILDI = '3',
    REDDEDILDI = '4',
}

export enum MeetingCompanyTypeEnum {
    POTANSIYEL_MUSTERI = '1',
    HEDEF_MUSTERI = '2',
    CALISILAN_MUSTERI = '3',
    KAYIP_MUSTERI = '4',
}

export enum GuaranteeTypeEnum {
    GTRANT_1 = '1'
}

export enum ProductTypeEnum {
    NORMAL = '1',
    YANICI = '2',
}

export enum ServiceIncomeTypeEnum {
    EK_HIZMET = '1',
}

export enum ServiceOutcomeTypeEnum {
    SÜRÜCÜ_GIDERI = '1',
    YAKIT_GIDERI = '3',
    ARAC_GIDERI = '2',
    SABIT_GIDER = '4',
    EK_HIZMET = '5',
}

export enum PersonnelDutyEnum {
    DEPOCU = '1',
    MUHASEBECI = '2',
    OPERATOR = '3',
    DEPO_MÜDÜRÜ = '4',
    OPERASYON_MÜDÜRÜ = '5',
    PAZARLAMA_MÜDÜRÜ = '6',
}

export enum AntrepoAreaTypeEnum {
    MAL_KABUL = '1',
    STOKLAMA = '2',
    MAL_CIKIS = '3',
}

export enum VehicleTypeEnum {
    YARI_ROMORK = '7',
    KAMYONET = '5',
    CEKICI_TIR = '2',
    IS_MAKINESI = '3',
    BINEK = '1',
    TREYLER_DORSE = '6',
    KAMYON = '4',
}

export enum AntrepoExitTypeEnum {
    DEVIR_CIKIS = 'AN',
    ITHALAT_CIKIS = 'IM',
    TRANSIT_CIKIS = 'LR',
}

export enum CompanyAddressTypeEnum {
    BOSALTMA_ADRESI = '3',
    YUKLEME_ADRES = '2',
    FATURA_ADRESI = '1',
}

export enum PotTypeEnum {
    KUTU = '9',
    PALET = '2',
    DOKME = '3',
    KONTEYNER = '8',
    BIG_BAG = '7',
    VARIL = '6',
    KOLI = '5',
    CUVAL = '4',
    ADET = '1',
}

export enum GsmOperatorEnum {
    TURKCELL = '1',
    VADOFONE = '2',
    TÜRK_TELEKOM = '3',
    NETGSM = '4',
}

export enum GsmStatusEnum {
    KAYIP = '3',
    STOKTA = '1',
    ARACTA_KULLANIMDA = '2',
}

export enum GsmCardTypeEnum {
    M2M_HATTI = '1',
    SES_HATTI = '2',
}

export enum GsmCardStatusEnum {
    AKTIF = '1',
    KAPALI = '2',
    IPTAL = '3',
}

export enum DeviceConnectionTypeEnum {
    CANBUS_BAGLANTI = '1',
    FMS_KABLO = '2',
    TACHO_KABLO = '3',
    KLASIK_BAGLANTI = '4',
}

export enum LastEventEventTypeEnum {
    EVENT = '0',
    WARNING = '1',
    BREACH = '2'
}

export enum InventoryStatusEnum {
    STOKTA = '1',
    ARACTA_KULLANIMDA = '2',
    KAYIP = '3',
}

export enum DeviceStatusEnum {
    SIFIR = '1',
    KULLANILMIS = '2',
    TADILATLI = '3',
    HURDA = '4',
}

export enum MultiplierTypeEnum {
    SIPARIS = '13',
    GUNLUK_BOLUM_GRUBU = '14'
}

/** Fiyat Bul'da Günlük Bölüm Grubu kararı: yalnız seçilenler ya da önceki siparişlerle birlikte. */
export enum PriceGroupDecisionEnum {
    SEPARATE = 'SEPARATE',
    TOGETHER = 'TOGETHER'
}

export enum OrderStatusAmbarEnum {
    OLUSTURULDU = '1',
    YUKLENDI = '2',
    TESLIM_EDILDI = '3',
    IPTAL_EDILDI = '4',
}

export enum CarryTypeEnum {
    YURTICI_KARGO = '1',
    ARAS_KARGO = '2',
    UCAK_KARGO = '3',
    OTOBUS_KARGO = '4',
    MOTO_KURYE = '5',
    GENEL = '6',
}

export enum ModuleEnum {
    ULUSLARARASI_KARA = '1',
    YURTICI_KARGO = '2',
    ANTREPO = '3',
    AMBAR = '4',
}

export enum SaleCategoryEnum {
    MUSTERI_FATURASI = '1',
    IADE_FATURASI = '2',
    KUR_FARKI_FATURASI = '3',
}

export enum InvoiceStatusEnum {
    FATURA = '1',
    IADE_FATURA = '2',
    IPTAL_FATURA = '3',
}

export enum CurrencyTypeEnum {
    SATIS = '1',
    ALIS = '2',
}

export enum InvoiceTypeEnum {
    TEMEL_FATURA = '1',
    TICARI_FATURA = '2',
}

export enum ProjectEnum {
    YURTICI_KARGO = '1',
    AMBAR = '2',
}

export enum WithholdingRateEnum {
    _2_10 = '1',
    _9_10 = '2',
}

export enum DocumentTypeYurticiEnum {
    IRSALIYE = '0',
    KONSIMENTO = '13',
}

export enum AmbarAgreementSchemeFieldEnum {
    YUKLEME_SEMT = '10',
    TESLIM_IL = '11',
    TESLIM_ILCE = '12',
    TESLIM_SEMT = '13',
    KAP_CINSI = '14',
    PALET_SAYISI = '15',
    ARAC_CINSI_ARAC_TANIMI = '16',
    ARAC_CINSI_2_ARAC_TANIMI = '18',
    GONDERICI_FIRMA = '19',
    ALICI_FIRMA = '20',
    BOLUM = '21',
    FIYATLANACAK_ARAC_CINSI_SEFER = '22',
    EK_LOKASYON = '23',
    MESAI_YOL_YEMEK = '24',
    HAMMALIYE = '25',
    TASIMA_TIPI = '2',
    // EKSPRES_ARAC = '3',
    BEKLEME_SURESI = '4',
    KOPRU_GECIS = '5',
    YUKLEME_BOLGESI = '6',
    TESLIM_BOLGESI = '7',
    YUKLEME_IL = '8',
    YUKLEME_ILCE = '9',
}

export enum CarryMethodEnum {
    NORMAL = '1',
    EKSPRES = '2',
}

export enum VehicleStatusEnum {
    KIRALIK = '1',
    OZMAL = '2',
    TEDARIK = '3',
}